function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useCallback } from 'react';
import { multiChoiceFilterValuesFrom } from '../multiChoiceFilterUtils';

/**
 * Hook to manage filtering state and logic for DataGrid
 * 
 * @param {boolean} enabled - Whether filtering is enabled
 * @param {Array} columns - Column definitions
 * @returns {Object} { filters, updateFilter, applyFilterValues, applyFilters }
 */
export function useDataGridFiltering(enabled, columns) {
  const [filters, setFilters] = useState({});
  const updateFilter = useCallback((columnKey, filterText) => {
    setFilters(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [columnKey]: filterText
    }));
  }, []);
  const applyFilterValues = useCallback(filterValues => {
    setFilters(filterValues || {});
  }, []);
  const applyFilters = useCallback(rows => {
    if (!enabled) return rows;
    const activeFilters = Object.entries(filters).filter(_ref => {
      let [_, value] = _ref;
      return value !== null && value !== undefined && value.toString().trim() !== '';
    });
    if (activeFilters.length === 0) return rows;

    // Separate totals rows from filterable rows
    const totalsRows = rows.filter(row => row.isTotalsRow);
    const filterableRows = rows.filter(row => !row.isTotalsRow);
    const filteredRows = filterableRows.filter(row => {
      // Row must pass ALL active filters
      return activeFilters.every(_ref2 => {
        let [columnKey, filterText] = _ref2;
        const columnIndex = parseInt(columnKey.replace('col_', ''));
        const column = columns[columnIndex];
        if (!(column !== null && column !== void 0 && column.valueFnForSortAndFilter)) return true;

        // Get the value using the valueFnForSortAndFilter function
        const wrappedRow = {
          data: {
            object: row
          }
        };
        const value = column.valueFnForSortAndFilter(wrappedRow);

        // Case-insensitive text matching
        const valueStr = String(value).toLowerCase();
        const filterValues = multiChoiceFilterValuesFrom(filterText).map(filterValue => filterValue.toLowerCase());
        if (filterValues.length === 0) return true;
        return filterValues.some(filterValue => valueStr.includes(filterValue));
      });
    });

    // Put totals rows back at the beginning
    return [...totalsRows, ...filteredRows];
  }, [enabled, filters, columns]);
  return {
    filters,
    updateFilter,
    applyFilterValues,
    applyFilters
  };
}